export default "__VITE_ASSET__982d576f__"